import Home from "./pages/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import First from "./pages/First";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Divein from "./pages/Divein";
import Formula from "./pages/Formula";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import Extract from "./pages/Extract";
import Paraphrasing from "./pages/Paraphrasing";
import Notemaking from "./pages/Notemaking";
import PriceTiers from "./components/PriceTiers";
import UpgradePlan from "./components/Payment";
import "./index.css";
import { useEffect } from "react";
import { server } from ".";
import { useContext } from "react";
import { Contextfirst } from ".";
import Videos from "./pages/Videos";
import Feedback from "./pages/Feedback";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  const { Setauthentication, Setuser } = useContext(Contextfirst);

  useEffect(() => {
    const check = async () => {
      const serverToast = toast.loading("Waking up Render Backend...");
      try {
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/checking`);
        toast.success("Connected successfully!", { id: serverToast });
      } catch (error) {
        toast.error("Failed to connect to backend.", { id: serverToast });
        console.error(error);
      }
    };

    check();
  }, []);

  useEffect(() => {
    axios
      .get(`${server}/users/me`, {
        withCredentials: true,
      })
      .then((res) => {
        Setuser(res.data.user.name);
        Setauthentication(true);
      })
      .catch(() => {
        Setauthentication(false);
      });
  }, [Setauthentication, Setuser]);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/notemaking" element={<Notemaking />} />
        <Route path="/paraphrase" element={<Paraphrasing />} />
        <Route path="/extract" element={<Extract />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/formula" element={<Formula />} />
        <Route path="/" element={<First />} />
        <Route path="/home" element={<Home />} />
        <Route path="/divein" element={<Divein />} />
        <Route path="/subscription" element={<PriceTiers />} />
        <Route path="/payment" element={<UpgradePlan />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/feedback" element={<Feedback />} />
      </Routes>
      <Toaster />
      <Footer />
    </Router>
  );
}

export default App;
